import React, { EffectCallback, FC, useCallback, useEffect, useRef, useState } from 'react'
import { landingApi } from 'Pages/landings/newLandings/common/api'
import {
	ERROR_LEAD_CODE_TRANSLATE,
	SECOND_LIMIT_TIMER_LEAD,
} from 'Pages/landings/newLandings/common/constants'
import { useForm } from 'Pages/landings/newLandings/common/hooks'
import { Callback, LeadCreate } from 'Pages/landings/newLandings/common/types'
import { required } from 'Pages/landings/newLandings/common/validators'
import { ButtonComponent } from 'Pages/landings/newLandings/common/components'
import moment from 'moment/moment'
import { StyledInnFormText, Input, BtnWrapper } from './styled'

interface ComponentProps {
	closeModal: Callback
	callbackCreateOrder?: Callback
	lead?: LeadCreate
}

const { completeLead, refreshSmsLead } = landingApi

export const SmsFormComponent: FC<ComponentProps> = ({ closeModal, callbackCreateOrder, lead }) => {
	const { createChangeHandler, getFormError, getFormValue, submit, setFormErrors, setFormValue } =
		useForm()

	const [timerSecond, setTimerSecond] = useState<number | undefined>()
	const [sms, setSms] = useState({ sms_created_at: lead?.sms_created_at })

	const timer = useRef<NodeJS.Timeout>(null)

	const [isLoading, setIsLoading] = useState(false)
	const changeLoading = () => setIsLoading((prevLoading) => !prevLoading)

	const startTimer = (sec: number): void => {
		clearTimeout(timer.current)
		const beginTimer = (seconds: number): void => {
			if (seconds > 1) {
				setTimerSecond(seconds - 1)
				clearTimeout(timer.current)
				timer.current = setTimeout(beginTimer, 1000, seconds - 1)
			} else {
				setTimerSecond(0)
			}
		}
		timer.current = setTimeout(beginTimer, 1000, sec)
	}

	const setTimer = useCallback((): void => {
		const second = moment(new Date()).diff(moment(sms.sms_created_at), 'seconds')
		if (second <= SECOND_LIMIT_TIMER_LEAD) startTimer(SECOND_LIMIT_TIMER_LEAD - second)
		else {
			setTimerSecond(0)
		}
	}, [sms.sms_created_at])

	useEffect((): void => {
		if (sms.sms_created_at) {
			setTimer()
		}
	}, [sms.sms_created_at])

	useEffect((): EffectCallback => {
		setTimer()
		return (): void => {
			clearTimeout(timer.current)
		}
	}, [])

	useEffect((): void => {
		setTimerSecond(timerSecond)
	}, [timerSecond])

	const seconds = timerSecond % 60

	const errorCallback = (errors) => {
		const key = Object.keys(errors?.[0])?.[0]
		const value = errors?.[0][key]
		const errText = ERROR_LEAD_CODE_TRANSLATE[value]
		setFormErrors((prevFormErrors) => ({
			...prevFormErrors,
			sms_code: { ...prevFormErrors.sms_code, errText },
		}))
		if (timerSecond > 0) {
			changeLoading()
		}
	}

	const handleSubmit = async () => {
		changeLoading()
		try {
			const callback = (res) => {
				// eslint-disable-next-line no-console
				console.log(res)
				callbackCreateOrder()
				closeModal()
				changeLoading()
			}
			completeLead(lead?.link_token, { user_code: getFormValue('sms_code') })
				.then((response) => {
					callback(response)
				})
				.catch((error) => errorCallback(error.data.errors))
		} catch (e) {
			changeLoading()
			// eslint-disable-next-line no-console
			console.log(e)
		}
	}

	const refreshSms = async () => {
		try {
			const callback = (res) => {
				setFormValue((prevFormValue) => ({
					...prevFormValue,
					sms_code: '',
				}))
				setFormErrors((prevFormErrors) => ({
					...prevFormErrors,
					sms_code: { ...prevFormErrors.sms_code, errText: '' },
				}))
				setSms((prevState) => ({
					...prevState,
					sms_created_at: res?.sms_created_at,
				}))
			}
			refreshSmsLead(lead?.id)
				.then((response) => {
					callback(response)
				})
				.catch((error) => errorCallback(error.data.errors))
		} catch (e) {
			// eslint-disable-next-line no-console
			console.log(e)
		}
	}
	const error = getFormError('sms_code')
	let timerText = ''
	if (timerSecond > 0) {
		timerText = `Отправить повторно можно через ${(timerSecond - seconds) / 60}:${
			seconds > 9 ? seconds : `0${seconds}`
		}`
	} else if (timerSecond === 0) {
		timerText = 'Отправить смс повторно'
	}
	return (
		<>
			<StyledInnFormText>На указанный номер телефона отправлено СМС с кодом</StyledInnFormText>
			<Input
				onChange={createChangeHandler({
					fieldName: 'sms_code',
					validation: [required()],
					initialValue: '',
				})}
				disabled={timerSecond === 0}
				placeholder="Введите код"
				name="sms_code"
				value={getFormValue('sms_code')}
				error={error}
				help={timerText}
				onClickHelp={timerSecond > 0 ? null : () => refreshSms()}
			/>
			<BtnWrapper>
				<ButtonComponent
					type="primary"
					measure="l"
					text="Подтвердить"
					disabled={Boolean(error) || timerSecond === 0}
					onClick={() => submit(handleSubmit)}
					isLoading={isLoading}
				/>
			</BtnWrapper>
		</>
	)
}
